module.exports = __webpack_public_path__ + "static/media/shopping-cart-alt.c6352a66.svg";